import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';

import getDefaultLanguage from './getDefaultLanguage';
import translations from './translations';

export const defaultLanguage = getDefaultLanguage();

export default i18n
    .use(initReactI18next)
    .init({
        debug: false,
        resources: translations,
        fallbackLng: defaultLanguage,
        react: { useSuspense: false },
    })
    .catch((error) => {
        console.log('i18n error: ', error);
    });
